/* eslint-disable import/no-unresolved */
import React from 'react';

import icon1SVG from 'assets/resources/pages/about-us/1_icon.svg';
import icon2SVG from 'assets/resources/pages/about-us/2_icon.svg';
import icon3SVG from 'assets/resources/pages/about-us/3_icon.svg';

import CultureItem from './CultureItem';

const Foundation = () => {
  return (
    <>
      <div className="icon-items">
        <h3>Why are we so effective?</h3>
        <div className="row">
          <CultureItem
            mainText="We believe in our customer’s ideas"
            secText="We are the first supporters of our customer’s products. 
            With the honest desire for them to succeed, we work with motivation as of the in-house team.
             We also trust founders, project managers, 
            and investors that we meet and crave to understand their needs first."
            img={icon1SVG}
          />
          <CultureItem
            mainText="Transparent communication and methodology"
            secText="We are agile and use Scrum to run projects. Maintaining a transparent flow of communication and an effective workflow is what guarantees success with software development. Thanks to that, all our processes and decisions are aligned with customer’s budgets and deadlines."
            img={icon2SVG}
          />

          <CultureItem
            mainText="We treat each other with respect"
            secText="Ulam Labs is a flat structure organization with roles instead of hierarchies. That translates to a unique sense of responsibility and makes an environment in which people and businesses thrive. The hook? We respect every single person for who they are."
            img={icon3SVG}
          />
        </div>
      </div>
    </>
  );
};

export default Foundation;
